import React from "react";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import LogoMarquee from "../components/landing/LogoMarquee";
import Features from "../components/landing/Features";
import WorkflowShowcase from "../components/landing/WorkflowShowcase";
import Omnichannel from "../components/landing/Omnichannel";
import ProductDemo from "../components/landing/ProductDemo";
import HowItWorks from "../components/landing/HowItWorks";
import UseCases from "../components/landing/UseCases";
import Testimonials from "../components/landing/Testimonials";
import Pricing from "../components/landing/Pricing";
import FAQ from "../components/landing/FAQ";
import CTA from "../components/landing/CTA";
import Footer from "../components/landing/Footer";

export default function LandingPage({ onDemoClick }) {
  return (
    <div className="relative noise" data-testid="landing-root">
      <Nav onDemoClick={onDemoClick} />
      <main>
        <Hero onDemoClick={onDemoClick} />
        <LogoMarquee />
        <Features />
        <WorkflowShowcase />
        <Omnichannel />
        <ProductDemo />
        <HowItWorks />
        <UseCases />
        <Testimonials />
        <Pricing onDemoClick={onDemoClick} />
        <FAQ />
        <CTA onDemoClick={onDemoClick} />
      </main>
      <Footer />
    </div>
  );
}
